<div class="toolbar left">
    <dx-button icon='menu' [visible]="!hideMenuButton" [disabled]="!hasMenu" (onClick)="onToggleMenu()"></dx-button>
    <dx-button icon='search' [visible]="!hideSearchButton" [disabled]="!hasSearch" (onClick)="onToggleSearch()"></dx-button>
    <dx-button icon='refresh' [visible]="!hideRefreshButton" [disabled]="!hasRefresh" (onClick)="onRefresh()"></dx-button>
</div>
